import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavBarComponent } from "./Components/nav-bar/nav-bar.component";
import { SuperNavBarComponent } from "./Components/super-nav-bar/super-nav-bar.component";
import { SystemNotificationComponent } from "./Components/system-notification/system-notification.component";
import { AngularMaterialModule } from "../DesignModules/angular-material.module";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "./Components/footer/footer.component";
import { SignInFormComponent } from "./Forms/sign-in-form/sign-in-form.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TabButtonComponent } from "./General/tab-button/tab-button.component";
import { ChangePasswordComponent } from "./Forms/change-password/change-password.component";
import { ProfileFormComponent } from "./Forms/profile-form/profile-form.component";
import { AlyleUiModule } from "../DesignModules/alyle-ui.module";
import { PaginatorModule } from "primeng/paginator";
import { ForgetPasswordEmailComponent } from "./Forms/ForgetPasswords/forget-password-email/forget-password-email.component";
import { ForgetPasswordCodeComponent } from "./Forms/ForgetPasswords/forget-password-code/forget-password-code.component";
import { ForgetPasswordChangePasswordComponent } from "./Forms/ForgetPasswords/forget-password-change-password/forget-password-change-password.component";
import { InformationCardTwoComponent } from "./General/Cards/information-card-two/information-card-two.component";
import { AddEditMembersComponent } from "./Dialoges/add-edit-members/add-edit-members.component";
import { CardComponent } from "./General/Cards/card/card.component";
import { CompanyInformationFormComponent } from "./Forms/company-information-form/company-information-form.component";
import { AddEditUserComponent } from "./Dialoges/add-edit-user/add-edit-user.component";
import { AddEditVesselComponent } from "./Dialoges/add-edit-vessel/add-edit-vessel.component";
import { CustomerSupportFormComponent } from "./Forms/customer-support-form/customer-support-form.component";
import { FinancialFormComponent } from "./Forms/financial-form/financial-form.component";
import { PaginationComponent } from "./General/pagination/pagination.component";
import { UserCardComponent } from "./General/Cards/user-card/user-card.component";
import { VesselCardComponent } from "./General/Cards/vessel-card/vessel-card.component";
import { InformationFunctionalCardComponent } from "./General/Cards/information-functional-card/information-functional-card.component";
import { CompanyCardComponent } from "./General/Cards/company-card/company-card.component";
import { AddEditCompanyComponent } from "./Dialoges/add-edit-company/add-edit-company.component";
import { SuccessComponent } from "./Dialoges/ResponseDIaloges/success/success.component";
import { ErrorComponent } from "./Dialoges/ResponseDIaloges/error/error.component";
import { MemberCardComponent } from "./General/Cards/member-card/member-card.component";
import { NotifierService } from "src/app/Components/Services/notifier.service";
import { SetPasswordFormComponent } from "./Forms/set-password-form/set-password-form.component";
import { AddEditPortComponent } from "./Dialoges/add-edit-port/add-edit-port.component";
import { PortCardComponent } from "./General/Cards/port-card/port-card.component";
import { PortInformationFormComponent } from "./Forms/port-information-form/port-information-form.component";
import { FinancialsPortFormComponent } from "./Forms/financials-port-form/financials-port-form.component";
import { VendorCardComponent } from "./General/Cards/vendor-card/vendor-card.component";
import { PrimeNgModule } from "../DesignModules/prime-ng.module";
import { AddEditVendorComponent } from "./Dialoges/add-edit-vendor/add-edit-vendor.component";
import { AssignNewVendorsComponent } from "./Dialoges/assign-new-vendors/assign-new-vendors.component";
import { AssignedVendorsCardComponent } from "./General/Cards/assigned-vendors-card/assigned-vendors-card.component";
import { VendorInformationFormComponent } from "./Forms/vendor-information-form/vendor-information-form.component";
import { VendorFinancialFormComponent } from "./Forms/vendor-financial-form/vendor-financial-form.component";
import { AssignNewPortsComponent } from "./Dialoges/assign-new-ports/assign-new-ports.component";
import { AssignedPortCardComponent } from "./General/Cards/assigned-port-card/assigned-port-card.component";
import { CategoryNavBarComponent } from "./Components/category-nav-bar/category-nav-bar.component";
import { CategoryCardComponent } from "./General/Cards/category-card/category-card.component";
import { CategoryAddCardComponent } from "./General/Cards/category-add-card/category-add-card.component";
import { CatalogCategoriesComponent } from "./General/Cards/catalog-categories-card/catalog-categories/catalog-categories.component";
import { ProductsListComponent } from "./General/Cards/products-list-card/products-list/products-list.component";
import { AddEditCategoryComponent } from "./Dialoges/add-edit-category/add-edit-category.component";
import { AddEditProductComponent } from "./Dialoges/add-edit-product/add-edit-product.component";
import { CropperComponent } from "./Dialoges/ResponseDIaloges/cropper/cropper.component";
import { PipeModule } from "../Pipes/pipe.module";
import { MarihubDiscountComponent } from "./Dialoges/marihub-discount/marihub-discount.component";
import { ShopProductsListComponent } from "./General/shop-products-list/shop-products-list.component";
import { SelectPortForOrderComponent } from "./Dialoges/select-port-for-order/select-port-for-order.component";
import { AssignProductComponent } from "./Dialoges/assign-product/assign-product.component";
import { EditVendorProductCostComponent } from "./Dialoges/edit-vendor-product-cost/edit-vendor-product-cost.component";
import { ShoppingAsComponent } from "./Dialoges/shopping-as/shopping-as.component";
import { ShoppingAsClientComponent } from "./Dialoges/shopping-as-client/shopping-as-client.component";
import { AddEditCommentComponent } from "./Dialoges/add-edit-comment/add-edit-comment.component";
import { EditOrderPortComponent } from "./Dialoges/edit-order-port/edit-order-port.component";
import { AddEditDeliveryDocumentsComponent } from "./Dialoges/add-edit-delivery-documents/add-edit-delivery-documents.component";
import { ExtraDesignModule } from "../DesignModules/extra-design.module";
import { AddEditVendorDocumentComponent } from "./Dialoges/add-edit-vendor-document/add-edit-vendor-document.component";
import { AddEditClientDocumentsComponent } from "./Dialoges/add-edit-client-documents/add-edit-client-documents.component";
import { MarkAsDeliveredComponent } from "./Dialoges/mark-as-deliveried/mark-as-delivered.component";
import { AuthFooterComponent } from "./Components/auth-footer/auth-footer.component";
import { ConfirmationComponent } from "src/app/Components/Dialoges/ResponseDIaloges/confirmation/confirmation.component";
import { EditItemComponent } from "./Dialoges/edit-item/edit-item.component";
import { ExportDeliveryNoteComponent } from "./Dialoges/Export/export-delviery-note/export-delivery-note.component";
import { AddEditClientContractComponent } from "./Dialoges/add-edit-client-contract/add-edit-client-contract.component";
import { AddToContractComponent } from "./Dialoges/add-to-contract/add-to-contract.component";
import { EditContractedItemPriceComponent } from "./Dialoges/edit-contracted-item-price/edit-contracted-item-price.component";
import { EditProcessingFeeComponent } from "./Dialoges/edit-processing-fee/edit-processing-fee.component";
import { ReplaceItemsComponent } from "./Dialoges/replace-items/replace-items.component";
import { IsContractedItemComponent } from "./Dialoges/Conracted/is-contracted-item/is-contracted-item.component";
import { IsNotContractedItemComponent } from "./Dialoges/Conracted/is-not-contracted-item/is-not-contracted-item.component";
import { AddEditItemSupplierComponent } from "./Dialoges/add-edit-item-supplier/add-edit-item-supplier.component";
import { VideoWorkComponent } from "./Dialoges/video-work/video-work.component";
import { OrderRatingComponent } from "./Dialoges/order-rating/order-rating.component";
import { ConfirmationEmailComponent } from "./Dialoges/confirmation-email/confirmation-email.component";

import { ShoppingCardComponent } from "./Dynamic/shopping-card/shopping-card.component";
import { ProductDetailsComponent } from "./Dialoges/product-details/product-details.component";
import { OrderBarComponent } from "./General/order-bar/order-bar.component";
import { GenerateNewOrderComponent } from "./Dialoges/generate-new-order/generate-new-order.component";
import { GenerateNewOrderVesselComponent } from "./Dialoges/generate-new-order-vessel/generate-new-order-vessel.component";
import { ViewOrderSummaryComponent } from "./Dialoges/view-order-summary/view-order-summary.component";
import { SubmitOrderComponent } from "./Dialoges/submit-order/submit-order.component";
import { RequestedItemComponent } from "./Dialoges/requested-item/requested-item.component";
import { ManageSuggestedItemsComponent } from "./Dialoges/manage-suggested-items/manage-suggested-items.component";
import { ContinueShoppingAsClientComponent } from "./Dialoges/continue-shopping-as-client/continue-shopping-as-client.component";
import { ViewSuggestedItemsComponent } from "./Dialoges/view-suggested-items/view-suggested-items.component";

import { ReAssignSupplierComponent } from "./Dialoges/re-assign-supplier/re-assign-supplier.component";
import { SupplierItemCommentComponent } from "./Dialoges/supplier-item-comment/supplier-item-comment.component";
import { ShareOrderComponent } from "./Dialoges/share-order/share-order.component";
import { MatIconModule } from "@angular/material/icon";
import { AddOrderBudgetComponent } from "./Dialoges/add-order-budget/add-order-budget.component";
import { OrderBudgetExceededComponent } from "./Dialoges/order-budget-exceeded/order-budget-exceeded.component";
import { UnauthNavBarComponent } from "./Components/unauth-nav-bar/unauth-nav-bar.component";
import { AddProductComponent } from "./Dialoges/add-product/add-product.component";
import { SalesOrderBarComponent } from "./General/sales-order-bar/sales-order-bar.component";
import { SendToSupplierComponent } from "./Dialoges/SalesEdit/send-to-supplier/send-to-supplier.component";
import { AddReplaceProductComponent } from "./Dialoges/SalesEdit/add-replace-product/add-replace-product.component";
import { ReplaceProductComponent } from "./Dialoges/SalesEdit/replace-product/replace-product.component";
import { SalesEditShoppingCardComponent } from "./Dynamic/sales-edit-shopping-card/sales-edit-shopping-card.component";
import { CatalogShoppingCardComponent } from "./Dynamic/catalog-shopping-card/catalog-shopping-card.component";
import { EditProductsComponent } from "./Dialoges/edit-products/edit-products.component";
import { SendSupplierCatalogComponent } from "./Dialoges/send-supplier-catalog/send-supplier-catalog.component";
import { FiltersMenuComponent } from "./BottomSheet/filters-menu/filters-menu.component";
import { ExportComponent } from "./BottomSheet/export/export.component";
import { SortComponent } from "./BottomSheet/sort/sort.component";
import { ActiveMenuComponent } from "./BottomSheet/active-menu/active-menu.component";
import { MenuUserComponent } from "./BottomSheet/cards-menu/menu-user/menu-user.component";
import { MenuVesselComponent } from "./BottomSheet/cards-menu/menu-vessel/menu-vessel.component";
import { MenuCompanyComponent } from "./BottomSheet/cards-menu/menu-company/menu-company.component";
import { MenuCategoryComponent } from "./BottomSheet/cards-menu/menu-category/menu-category.component";
import { MenuPortComponent } from "./BottomSheet/cards-menu/menu-port/menu-port.component";
import { MenuVendorComponent } from "./BottomSheet/cards-menu/menu-vendor/menu-vendor.component";
import { CommentPopupComponent } from "./Dialoges/comment-popup/comment-popup.component";
import { AddPreferredSupplierComponent } from "./Dialoges/add-preferred-supplier/add-preferred-supplier.component";
import { MessageService } from "primeng/api";
import { NavBarV2Component } from "./Components/nav-bar-v2/nav-bar-v2.component";
import { FooterV2Component } from "./Components/footer-v2/footer-v2.component";
import { LandingSplashV2Component } from "./Components/landing-splash-v2/landing-splash-v2.component";
import { LandingV2Component } from "./Components/landing-v2/landing-v2.component";
import { HeroV2Component } from "./Components/hero-v2/hero-v2.component";
import { StatisticsV2Component } from "./Components/statistics-v2/statistics-v2.component";
import { SolutionsV2Component } from "./Components/solutions-v2/solutions-v2.component";
import { SolutionComponent } from "./Components/solution/solution.component";
import { OurServicesV2Component } from "./Components/our-services-v2/our-services-v2.component";
import { ExportOrderComponentComponent } from "./Dialoges/Export/export-order-component/export-order-component.component";
import { ExportOrderToPdfComponent } from "./Dialoges/Export/export-order-to-pdf/export-order-to-pdf.component";
import { ItemsFiltersCardComponent } from "./Dynamic/items-filters-card/items-filters-card.component";
import { MenuSelectClientComponent } from "./BottomSheet/cards-menu/menu-select-client/menu-select-client.component";
import { AddEditBrandComponent } from "./Dialoges/add-edit-brand/add-edit-brand.component";
import { BrandCardComponent } from "./General/Cards/brand-card/brand-card.component";
import { MenuBrandComponent } from "./BottomSheet/cards-menu/menu-brand/menu-brand.component";
import { ContactV2Component } from "./Components/contact-v2/contact-v2.component";

import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { ImportItemsOrderComponent } from "./Dialoges/import-items-order/import-items-order.component";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    NavBarComponent,
    SuperNavBarComponent,
    SystemNotificationComponent,
    FooterComponent,
    SignInFormComponent,
    TabButtonComponent,
    ChangePasswordComponent,
    ProfileFormComponent,
    ForgetPasswordEmailComponent,
    ForgetPasswordCodeComponent,
    ForgetPasswordChangePasswordComponent,
    InformationCardTwoComponent,
    AddEditMembersComponent,
    CardComponent,
    CompanyInformationFormComponent,
    AddEditUserComponent,
    AddEditVesselComponent,
    CustomerSupportFormComponent,
    FinancialFormComponent,
    PaginationComponent,
    UserCardComponent,
    VesselCardComponent,
    InformationFunctionalCardComponent,
    CompanyCardComponent,
    AddEditCompanyComponent,
    SuccessComponent,
    ErrorComponent,
    MemberCardComponent,
    SetPasswordFormComponent,
    AddEditPortComponent,
    PortCardComponent,
    PortInformationFormComponent,
    FinancialsPortFormComponent,
    VendorCardComponent,
    AddEditVendorComponent,
    AssignNewVendorsComponent,
    AssignedVendorsCardComponent,
    VendorInformationFormComponent,
    VendorFinancialFormComponent,
    AssignNewPortsComponent,
    AssignedPortCardComponent,
    CategoryNavBarComponent,
    CategoryCardComponent,
    CategoryAddCardComponent,
    CatalogCategoriesComponent,
    ProductsListComponent,
    AddEditCategoryComponent,
    AddEditProductComponent,
    CropperComponent,
    MarihubDiscountComponent,
    ShopProductsListComponent,
    SelectPortForOrderComponent,
    AssignProductComponent,
    EditVendorProductCostComponent,
    ShoppingAsComponent,
    ShoppingAsClientComponent,
    AddEditCommentComponent,
    EditOrderPortComponent,
    AddEditDeliveryDocumentsComponent,
    AddEditVendorDocumentComponent,
    AddEditClientDocumentsComponent,
    MarkAsDeliveredComponent,
    AuthFooterComponent,
    ConfirmationComponent,
    EditItemComponent,
    ExportDeliveryNoteComponent,
    AddEditClientContractComponent,
    AddToContractComponent,
    EditContractedItemPriceComponent,
    EditProcessingFeeComponent,
    ReplaceItemsComponent,
    IsContractedItemComponent,
    IsNotContractedItemComponent,
    AddEditItemSupplierComponent,
    VideoWorkComponent,
    OrderRatingComponent,
    ConfirmationEmailComponent,
    ShoppingCardComponent,
    ProductDetailsComponent,
    OrderBarComponent,
    GenerateNewOrderComponent,
    GenerateNewOrderVesselComponent,
    ViewOrderSummaryComponent,
    SubmitOrderComponent,
    RequestedItemComponent,
    ManageSuggestedItemsComponent,
    ContinueShoppingAsClientComponent,
    ViewSuggestedItemsComponent,
    ReAssignSupplierComponent,
    SupplierItemCommentComponent,
    ShareOrderComponent,
    AddOrderBudgetComponent,
    OrderBudgetExceededComponent,
    UnauthNavBarComponent,
    AddProductComponent,
    SalesOrderBarComponent,
    SendToSupplierComponent,
    AddReplaceProductComponent,
    ReplaceProductComponent,
    SalesEditShoppingCardComponent,
    CatalogShoppingCardComponent,
    EditProductsComponent,
    SendSupplierCatalogComponent,
    FiltersMenuComponent,
    ExportComponent,
    SortComponent,
    ActiveMenuComponent,
    MenuUserComponent,
    MenuVesselComponent,
    MenuCompanyComponent,
    MenuCategoryComponent,
    MenuPortComponent,
    MenuVendorComponent,
    CommentPopupComponent,
    AddPreferredSupplierComponent,
    NavBarV2Component,
    FooterV2Component,
    LandingSplashV2Component,
    LandingV2Component,
    HeroV2Component,
    StatisticsV2Component,
    SolutionsV2Component,
    SolutionComponent,
    OurServicesV2Component,
    ExportOrderComponentComponent,
    ExportOrderToPdfComponent,
    ItemsFiltersCardComponent,
    MenuSelectClientComponent,
    AddEditBrandComponent,
    BrandCardComponent,
    MenuBrandComponent,

    ContactV2Component,
    ImportItemsOrderComponent,
  ],
  exports: [
    SuperNavBarComponent,
    NavBarComponent,
    FooterComponent,
    SignInFormComponent,
    TabButtonComponent,
    ChangePasswordComponent,
    ProfileFormComponent,
    ForgetPasswordEmailComponent,
    ForgetPasswordCodeComponent,
    ForgetPasswordChangePasswordComponent,
    InformationCardTwoComponent,
    CardComponent,
    CompanyInformationFormComponent,
    CustomerSupportFormComponent,
    FinancialFormComponent,
    PaginationComponent,
    UserCardComponent,
    VesselCardComponent,
    InformationFunctionalCardComponent,
    CompanyCardComponent,
    MemberCardComponent,
    SetPasswordFormComponent,
    PortCardComponent,
    PortInformationFormComponent,
    FinancialsPortFormComponent,
    VendorCardComponent,
    AssignedVendorsCardComponent,
    VendorInformationFormComponent,
    VendorFinancialFormComponent,
    AssignedPortCardComponent,
    CategoryNavBarComponent,
    CategoryCardComponent,
    CategoryAddCardComponent,
    CatalogCategoriesComponent,
    ProductsListComponent,
    ShopProductsListComponent,
    AuthFooterComponent,
    ShoppingCardComponent,
    OrderBarComponent,
    UnauthNavBarComponent,
    AddProductComponent,
    SalesOrderBarComponent,
    SendToSupplierComponent,
    SalesEditShoppingCardComponent,
    CatalogShoppingCardComponent,
    EditProductsComponent,
    SendSupplierCatalogComponent,
    FiltersMenuComponent,
    ExportComponent,
    SortComponent,
    ActiveMenuComponent,
    MenuUserComponent,
    MenuVesselComponent,
    MenuCompanyComponent,
    MenuCategoryComponent,
    MenuPortComponent,
    MenuVendorComponent,
    NavBarV2Component,
    FooterV2Component,
    LandingSplashV2Component,
    LandingV2Component,
    HeroV2Component,
    StatisticsV2Component,
    SolutionsV2Component,
    SolutionComponent,
    OurServicesV2Component,
    ExportOrderComponentComponent,
    ExportOrderToPdfComponent,
    ItemsFiltersCardComponent,
    MenuSelectClientComponent,
    AddEditBrandComponent,
    BrandCardComponent,
    MenuBrandComponent,
    ContactV2Component,
    ImportItemsOrderComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    RouterModule,
    ReactiveFormsModule,
    AlyleUiModule,
    PaginatorModule,
    PrimeNgModule,
    PipeModule,
    ExtraDesignModule,
    NgxIntlTelInputModule,
  ],
  providers: [NotifierService, MessageService],
})
export class ReUsableModule {}
